import React, {useState} from 'react'
import {css} from '@emotion/react'
import {colors} from '../constants'
import StartMailIcon from '../images/icon-startmail.svg'

import HamburgerMenuIcon from '../images/hamburgerMenuIcon.svg'

const HamburgerMenu = ({links, overrideStyles = ``}) => {
    const [show, setShow] = useState(false)
    const toggle = () => {
        setShow(!show)
    }
    const OFFSET = `-260px`

    return (
        <div
            className="hamburgerMenu"
            css={css`
                ${overrideStyles}
            `}
        >
            <button
                css={css`
                    border: none;
                    background: transparent;
                    &:hover {
                        cursor: pointer;
                    }
                `}
                onClick={toggle}
            >
                <HamburgerMenuIcon />
            </button>
            <div
                className="hamburgerMenuDrawer"
                css={css`
                    z-index: 999;
                    border-radius: 4px;
                    width: 262px;
                    padding: 40px 24px;
                    height: 100vh;
                    position: fixed;
                    top: 0;
                    right: ${OFFSET};
                    transition: all 0.2s ease;
                    ${show
                        ? `
                            right: 0;
                            background: ${colors.whisper};
                            border: 1px solid ${colors.whisperDark};
                        `
                        : `
                            right: ${OFFSET};
                        `}
                    a {
                        color: ${colors.midnight};
                        display: block;
                        margin: 0 0 1.5rem;
                        &:hover {
                            color: ${colors.brandBlue};
                            cursor: pointer;
                        }
                    }
                `}
            >
                {links.map(({text, url}, i) => {
                    return (
                        <a href={url} target="_blank" key={i} rel="noopener noreferrer">
                            {text === 'StartMail' && (
                                <StartMailIcon
                                    css={css`
                                        margin-right: 8px;
                                    `}
                                />
                            )}
                            {text}
                        </a>
                    )
                })}
            </div>
            <div
                className="mask"
                id="hamburger-mask"
                css={css`
                    z-index: 998;
                    background: rgba(0, 0, 0, 0.5);
                    top: 0;
                    left: 0;
                    height: 100vh;
                    width: 100vw;
                    position: fixed;
                    display: ${show ? 'block' : 'none'};
                    opacity: ${show ? '1' : '0'};
                    transition: all 0.2s ease;
                `}
                onClick={toggle}
                onKeyUp={toggle}
                role="menu"
                tabIndex="-1"
                aria-label="hamburger menu"
            />
        </div>
    )
}

export default HamburgerMenu
